var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('h5',{staticClass:"title is-5"},[_vm._v("\r\n    ОБЩИ УСЛОВИЯ ЗА ПРЕДОСТАВЯНЕ НА КРЕДИТИ ЗА НЕДВИЖИИ ИМОТИ НА ПОТРЕБИТЕЛИ\r\n")]),_vm._v(" "),_c('div',{staticClass:"pre",attrs:{"id":"general-terms"}},[_vm._v("\r\n  "+_vm._s(_vm.generalTermsText)+"\r\n")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19fa8fb6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/policies/GeneralTerms.vue
// module id = null
// module chunks = 